//Ids generados aleatoriamente https://www.random.org/strings/?num=10&len=4&digits=on&upperalpha=on&loweralpha=on&unique=on&format=html&rnd=new
//SeIj
//qzwt
//zoOU
//z5Qq
//ntnF
//gQUk
//2E9K
//iEaD
//Uwgv
export default [
  {
    id: "xx4I",
    title: "Modelo Cafetera BP",
    description:
      "Lorem ipsum dolor amet leggings microdosing man bun, YOLO normcore four loko authentic poke. Man braid wolf cornhole YOLO, cronut succulents chambray fashion axe. Whatever truffaut lomo distillery meditation marfa, shaman quinoa selvage retro la croix bushwick banh mi kitsch. Glossier blog chillwave vinyl vice. Etsy sustainable bespoke art party kitsch hashtag mlkshk cold-pressed kinfolk selfies. Tumblr deep v shabby chic, authentic gochujang pour-over selvage tofu next level street art pitchfork viral knausgaard polaroid. Everyday carry authentic truffaut marfa retro.",
    btns: {
      numFilas: 5,
      numColumnas: 2,
      items: [
        {
          cod_producto: 1,
          leyenda: "Café espresso",
          pos: {
            f: 1, //fila 1
            c: 1, //columna 1
          },
          img: {
            id: 1,
            name: "Café espresso",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 2,
          leyenda: "Café largo",
          pos: {
            f: 2, //fila
            c: 1, //columna
          },
          img: {
            id: 1,
            name: "Café largo",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 3,
          leyenda: "Café cortado",
          pos: {
            f: 3, //fila
            c: 1, //columna
          },
          img: {
            id: 1,
            name: "Café cortado",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 4,
          leyenda: "Café descafeinado",
          pos: {
            f: 4, //fila
            c: 1, //columna
          },
          img: {
            id: 1,
            name: "Café descafeinado",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 5,
          leyenda: "Cortado descafeinado",
          pos: {
            f: 5, //fila
            c: 1, //columna
          },
          img: {
            id: 1,
            name: "Cortado descafeinado",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 6,
          leyenda: "Café con leche",
          pos: {
            f: 1, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Café con leche",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 7,
          leyenda: "Cappuccino ",
          pos: {
            f: 2, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Cappuccino ",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 8,
          leyenda: "Cappuccino vainilla",
          pos: {
            f: 3, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Cappuccino vainilla",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 9,
          leyenda: "Chocolate",
          pos: {
            f: 4, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Chocolate",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 10,
          leyenda: "Chocolate con leche",
          pos: {
            f: 5, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Chocolate con leche",
            url: "/assets/dummy.png"
          }
        },
        // {
        //   cod_producto: 9999,
        //   leyenda: "Azúcar",
        //   esAzucar: true,
        //   pos: {
        //     f: 1, //fila
        //     c: 3, //columna
        //   },
        //   img: {
        //     id: 1,
        //     name: "Azúcar",
        //     url: "/assets/dummy.png"
        //   }
        // },
      ]
    },
    image: {
      id: 1,
      name: "product-1.png",
      url: "/assets/product-images/product-1.png",
    }
  },
];
